const SelfServe = `
    store_flg,              allow_eatin,                          false,          8;
    store_flg,              require_table_num,                    false,          13;
    store_flg,              require_scan_instore,                 false,          39;
    store_flg,              require_due_time_for_in_store_order,  false,          76;
    store_flg,              require_store_poster,  false;
    store_flg,              require_arbitrary_code,  false;
    store_addr,             store_addr,                           false;
    general_info.phone,     phone,                                false;
    general_info.store_nm,  store_name,                           true;
    general_info.g_id,      store_id,                             false;
    store_flg,              sync_cart_with_server,                false,          77;
`;

export default SelfServe;
